import { PaletteColorType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class HeadlineCategory extends BaseCategory {
    get name() {
        return "Headline";
    }

    get type() {
        return SlideCategories.HEADLINE;
    }

    get icon() {
        return null;
    }

    get description() {
        // return "The content is focused on presenting a single headline, mission statement, or slogan. May include an optional supporting subheadline but use Text category if the content contains a list or multiple paragrapphs of body text.";
        return "The content is a single headline, mission statement, or slogan without bullet points or descriptive text.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Provide a compelling headline, mission statement, tagline, or slogan along with an optional supporting subheadline.`;
    }

    getPromptSchema() {
        return {
            headline: "the main headline, mission statement, tagline, or slogan",
            subheadline: "optional subheadline (can be empty string if not needed)",
        };
    }

    getSlideModels(model) {
        let models = [
            // this.buildHeadline(model, true, "center"),
            this.buildHeadline(model, true, "center", { fontColor: "primary" }, { filterBrightness: 0.33 }),
            // this.buildHeadline(model, true, "center", { fontColor: "black" }, { mediaOpacity: 0.3 }),
            this.buildHeadline(model, true, "right"),
            this.buildHeadline(model, false, "center"),
        ];

        return models;
    }

    buildHeadline(model, showImage, headlinePosition, fontOptions = {}, imageOptions = {}) {
        let builder = new SlideModelBuilder("headline2", model);

        let textStyle = model.headline.length > 100 ? TextStyleType.HEADING : TextStyleType.HEADLINE;

        let blocks = [
            builder.createBlock(model.headline, textStyle, fontOptions)
        ];

        // Add subheadline if it exists and is not empty
        if (model.subheadline && typeof model.subheadline == "string" && model.subheadline.trim().length > 0) {
            blocks.push({ type: "divider", dividerWidth: "short" });
            blocks.push(builder.createBlock(model.subheadline, TextStyleType.BODY, fontOptions));
        } else if (model.subheadline && Array.isArray(model.subheadline)) {
            blocks = model.subheadline;
        }

        let primary = {
            fullBleed: true,
            showGutter: false,
            headlinePosition,
            textPosition: headlinePosition == "right" ? "left" : "center",
            textAlign: headlinePosition == "right" ? "left" : "center",
            text: {
                blocks: blocks
            },
        };

        if (showImage && model.slideImage?.prompt) {
            primary.items = [{
                componentType: "TextAndImage",
                childElement: builder.createImage(model.slideImage?.prompt, imageOptions, true)
            }];
        } else {
            builder.setBackgroundColor(PaletteColorType.ACCENT1);
        }

        builder.createPrimary(primary);
        return builder.model;
    }
}
